<header class="header">
  <div class="header-top">
    <div class="container header-container">
      <!-- Logo -->
      <div class="header-logo">
        <a routerLink="/" class="logo-link">
          <img src="assets/images/logo.png" alt="Alves Faróis & Auto Peças" class="logo-img">
        </a>
      </div>

      <!-- Busca (Desktop) -->
      <div class="header-search d-mobile-none">
        <app-search-bar></app-search-bar>
      </div>

      <!-- Menu Mobile Toggle -->
      <button 
        class="mobile-menu-toggle d-desktop-none"
        (click)="toggleMobileMenu()"
        [attr.aria-label]="mobileMenuOpen() ? 'Fechar menu' : 'Abrir menu'"
      >
        @if (mobileMenuOpen()) {
          <img src="assets/icons/close.svg" alt="Fechar" width="28" height="28">
        } @else {
          <img src="assets/icons/menu.svg" alt="Menu" width="28" height="28">
        }
      </button>
    </div>
  </div>

  <!-- Busca Mobile -->
  <div class="header-search-mobile d-desktop-none">
    <div class="container">
      <app-search-bar></app-search-bar>
    </div>
  </div>

  <!-- Menu de Navegação (Mobile) -->
  @if (mobileMenuOpen()) {
    <div class="mobile-menu d-desktop-none" (click)="closeMobileMenu()">
      <nav class="mobile-nav">
        <a routerLink="/" class="mobile-nav-item">Início</a>
        <a routerLink="/produtos" class="mobile-nav-item">Todos os Produtos</a>
        <a routerLink="/categoria/farois" class="mobile-nav-item">Faróis</a>
        <a routerLink="/categoria/lanternas" class="mobile-nav-item">Lanternas</a>
        <a routerLink="/categoria/retrovisores" class="mobile-nav-item">Retrovisores</a>
      </nav>
    </div>
  }
</header>

